<template>
  <div>
    <slot name="introContent"></slot>
    <div v-show="(dynamicExpander && !expanded) || !dynamicExpander" :class="{ 'flex justify-center': centerToggle }">
      <ShowHideButton
        :showMore="expanded"
        :showMoreLabel="toggleButtonExpandText"
        :showLessLabel="toggleButtonCollapseText"
        @click="expanded = !expanded"
      ></ShowHideButton>
    </div>
    <div v-show="expanded" :class="{ 'mt-6': expanded && !centerToggle }">
      <slot name="conditionalContent"></slot>
    </div>
    <div v-show="dynamicExpander && expanded" :class="{ 'flex justify-center': centerToggle }">
      <ShowHideButton
        :showMore="expanded"
        :showMoreLabel="toggleButtonExpandText"
        :showLessLabel="toggleButtonCollapseText"
        @click="expanded = !expanded"
      ></ShowHideButton>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import ShowHideButton from '../ShowHideButton/ShowHideButton.vue';

defineProps<{
  toggleButtonExpandText: string;
  toggleButtonCollapseText: string;
  dynamicExpander?: boolean;
  centerToggle?: boolean;
}>();

const expanded = ref<boolean>(false);
</script>
